import sha1 from 'js-sha1';

const SECRET = "f10e2821bbbea527ea02200352313bc059445190";
const EVENTS = {};
// hashlib.sha1(('1114'+"f10e2821bbbea527ea02200352313bc059445190").encode('UTF-8')).hexdigest()[0:4]
// 55750-39f4
const MEMBERS = {
    55750: {swsnr: "55750", firstname: "Sandro", lastname: "Mani", membernr: 1114, phone: "123 456 78 90", email: "mail@example.com"}
};

function findMember(code) {
    const parts = code.trim().split("-");
    if (parts.length !== 2) {
        return null;
    }
    const swsnr = parts[0].trim();
    const chk = parts[1].trim();

    const member = MEMBERS[swsnr];
    if (!member) {
        return null;
    }
    const checksum = sha1(member.membernr + SECRET).slice(0, 4);
    return checksum === chk ? member : null;
}

export default class MockApi {
    static createEvent(date, code, callback) {
        const key = date.format("YYYYMMDD");
        const member = findMember(code);
        if (key in EVENTS) {
            callback(false, "Data già occupata");
        } else if (!member) {
            callback(false, "Codice errato");
        } else {
            EVENTS[key] = {
                ...member,
                date: date
            };
            callback(true);
        }
    }
    static deleteEvent(event, code, callback) {
        const key = event.date.format("YYYYMMDD");
        const member = findMember(code);
        if (!(key in EVENTS)) {
            callback(false, "Registrazione inesistente");
        } else if (!member) {
            callback(false, "Codice errato");
        } else {
            delete EVENTS[key];
            callback(true);
        }
    }
    static getEvents(start, end, callback) {
        const events = Object.entries(EVENTS).reduce((res, [key, event]) => {
            if (key.slice(0, 6) >= start.format('YYYYMM') && key.slice(0, 6) <= end.format('YYYYMM')) {
                res[key] = event;
            }
            return res;
        }, {});
        setTimeout(() => {
            callback(events);
        }, 1000);
    }
    static queryContact(event, code, callback) {
        const key = event.date.format("YYYYMMDD");
        const member = findMember(code);
        if (!(key in EVENTS)) {
            callback(false, "Registrazione inesistente");
        } else if (!member) {
            callback(false, "Codice errato");
        } else if (!(EVENTS[key].swsnr in MEMBERS)) {
            callback(false, "Membro sconosciuto");
        } else {
            const data = MEMBERS[EVENTS[key].swsnr];
            callback(true, {
                email: data.email,
                phone: data.phone
            });
        }
    }

}
